export const locationFullUrl = (location: Pick<Location, "pathname" | "search" | "hash">): string =>
  `${location.pathname}${location.search}${location.hash}`;
